import { createSlice } from '@reduxjs/toolkit';
import { fetchUserInfoBuilder, getDeliveryUsersBuilder, loginBuilder, signUpBuilder, verifyEmailBuilder } from './builder';

const initialState = {
  user: {
    id: null,
    email: '',
    fullName: '',
    verified: false,
    lang: null,
  },

  deliveryUsers: {
    data: [],
    maxReached: false,
    total: 0,
    page: 1,
  },

  fetchUserInfoPending: false,
  verifyEmailPending: false,
  getDeliveryUsersPending: false,
};

export const userSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    fetchUserInfoBuilder(builder);
    signUpBuilder(builder);
    loginBuilder(builder);
    verifyEmailBuilder(builder);
    getDeliveryUsersBuilder(builder);
    builder.addCase('logout', () => ({ ...initialState, loggedIn: false }));
  },
});

// export const {} = userSlice.actions;

export const selectUserInfo = state => state.userInfo.user;

export const selectFetchUserPending = state => state.userInfo.fetchUserInfoPending;

export const selectVerifyEmailPending = state => state.userInfo.verifyEmailPending;

export const selectDeliveryUsers = state => state.userInfo.deliveryUsers;

export const selectGetDeliveryUsersPending = state => state.userInfo.getDeliveryUsersPending;

export default userSlice.reducer;
